export enum TokenTypesEnum {
  SERVICE = 'service',
  APP = 'app',
}
